/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ButtonBase, Icon } from "..";

import "./ResourceInput.scss";

export interface IResourceInputProps {
	children?: React.ReactNode;
	className?: string;
	onClick?: React.MouseEventHandler;
	disabled?: boolean;
	endAdornment?: React.ReactNode;
	tooltip?: string;
	onClear?: () => void;
}

export const ResourceInput = React.forwardRef<HTMLDivElement, IResourceInputProps>(
	({ children, className, onClick, disabled, endAdornment, tooltip, onClear }, ref) => {
		const baseClass = BEM("edt-resource-input");

		if (className) {
			baseClass.add(className);
		}

		return (
			<ButtonBase
				Component="div"
				ref={ref}
				onClick={onClick}
				disabled={disabled}
				className={baseClass.toClassName()}
				title={tooltip}
			>
				<div className={baseClass.element("icon-wrapper").toClassName()}>
					<Icon className={baseClass.element("icon").toClassName()} name="mdi/folder-open" />
				</div>
				<span className={baseClass.element("value").toClassName()}>{children}</span>
				{endAdornment}
			</ButtonBase>
		);
	}
);
